/**
 * Libellés de la Carte info que les deux inspecteurs affichent pour la même
 * prop : le panneau de droite du document et celui du site. Ils les écrivaient
 * chacun de leur côté (« Interligne » d'un côté, « Espace entre les lignes » de
 * l'autre) : un seul endroit, pour que le mot ne change pas d'un éditeur à
 * l'autre.
 */
export const INFO_CARD_GROUPS = {
  illustration: 'Illustration',
  texts: 'Textes',
  decor: 'Décor',
  card: 'Carte',
};

export const INFO_CARD_LABELS = {
  cardLayout: 'Disposition',
  contentAlign: 'Alignement',
  lineGap: 'Interligne',
  backgroundColor: 'Couleur de fond',
  quoteMark: 'Guillemet décoratif',
  rating: 'Note sur 5',
  ratingColor: 'Couleur des étoiles',
  ratingSize: 'Taille des étoiles',
  badges: 'Badges',
};
